<template>
  <div>
      <b-toast
      id="toast-check-my-course"
      variant="none"
      no-close-button
      toaster="b-toaster-top-center"
    >
      <img
        src="@/assets/img/ico-check.png"
        style="margin-right: 10px; margin-top: -2px"
      />
      {{ message }}
    </b-toast>
    <b-toast
      id="toast-equis-my-course"
      variant="none"
      no-close-button
      toaster="b-toaster-top-center"
    >
      <img
        src="@/assets/img/ico-equis.png"
        style="margin-right: 10px; margin-top: -2px"
      />
      {{ message }}
    </b-toast>
    <b-breadcrumb>
      <b-breadcrumb-item active>{{$t('my-cours.title')}}</b-breadcrumb-item>
    </b-breadcrumb>
    <b-tabs class="sm" v-model="tabIndex" ref="refContentTabs">
      <b-tab :title="$t('my-cours.nav-tab-1.title')" lazy :disabled="!FlagViewFirstOption || groupsPlan==null" @click="toggleShowDivContent()">
        <div v-if="showLoadingFirst" class="container-loading">
            <b-spinner :label="$t('reusables.loading')" ></b-spinner>
        </div>
        <div v-else class="cards-wrap justify-content-between">
          <div class="card-course" v-for="(item) in subjectLevels"  :key="item.id" :id="'subjectLevels_'+item.id" >
            <img :src="getImgObjetivoUrl(cursosJson.cursos.find(el => el.id == item.id) != null ? cursosJson.cursos.find(el => el.id == item.id).image : 'Objetivo 2.png')" />
            <div class="content">
              <h6 class="bold mb-2">{{ lang == "es" ? item.nameSubject: item.nameSubject_EN}}</h6>
              <b-button variant="primary" @click="showModalDetalle(item.subject.programId,item)">
                <span :id="'tooltipObject_'+item.id"  class="icon-info"><icon name="info" /></span>
                {{$t('my-cours.nav-tab-1.btn-info')}}
              </b-button>
              <b-tooltip :target="'tooltipObject_'+item.id" placement="bottom">texto</b-tooltip>
              <div v-if="!flagFlagGroup && flagDropOut" class="mt-3"><b-link class="link-danger bold" @click="leaveCouse(item)" >{{$t('my-cours.nav-tab-1.btn-abandoned')}}</b-link></div>
            </div>
          </div>
        </div>
        <ModalCursoDetalle ref="modalCursoDetalle" :datosCurso="datosCurso" />
		    <ModalCursoDetalle2 :datosExam="datosExam"/>
      </b-tab>
      <b-tab :title="$t('my-cours.nav-tab-2.title')" lazy  :disabled="flagFlagGroup || ((groupPlanId >0 && listSubjectLevelIds.length==0)==true?false: nroChangeSubject>0? false : true)">
        <div v-show="!flagMostrar" class="container-loading">
            <b-spinner :label="$t('reusables.loading')" ></b-spinner>
        </div>
        <Cursos ref="refCursos" :key="childComponentKey"
          v-show="flagMostrar"
          :list-subject="listSubjectLevelIds"
          :group-plan-id ="groupPlanId"
          @update-course='handleUpdateCourse()'
          @update-flag='changeStateFlag'
          :flag-show-buttons="FlagViewFirstOption"
          :group-data="group" :flag-gestionar-cursos="true"
        />
      </b-tab>
    </b-tabs>
       <div v-if="!flagFlagGroup">
            <div class="card px-5 mt-4 change_course"  v-if="tabIndex==0 && !showLoadingFirst">
      <b-row class="align-items-center">
        <b-col cols="7">
          <div class="d-flex align-items-center">
            <img src="@/assets/img/materials-books-2.png" />
            <ul class="list-ul ml-5">
              <li>{{$t('my-cours.change-cours-li-1', { LSC: limitSubjectChanges})}}</li>
              <li>{{$t('my-cours.change-cours-li-2', {NCS: nroChangeSubject>0? nroChangeSubject : '0'})}}</li>
            </ul>
          </div>
        </b-col>
        <b-col class="pl-5">
          <p class="mb-0">{{$t('my-cours.change-cours-info')}}: </p>
          <b-button variant="primary" class="mt-2" @click="tabIndex=1" :disabled="flagFlagGroup || nroChangeSubject<1">
            {{$t('my-cours.change-cours-btn')}}
          </b-button>
        </b-col>
      </b-row>
    </div>
       </div>

      <b-modal id="modal-leave" :centered="true">
           <template #modal-header="{ close }">
              <img class="close" src="@/assets/img/close_red.png" @click="close()">
            </template>
            <p class="text-center mb-0" >{{$t('modals.modelLeave.text')}}</p>  
          <template #modal-footer>
            <b-button  @click="$bvModal.hide('modal-leave')" variant="danger">
              {{$t('modals.cancel-request.button-cancel')}}
           
            </b-button>

             <b-button @click="handleLeaveCourse" variant="primary">
                <template v-if="!showSpinnerSave">{{$t('modals.cancel-request.button-confirm')}}</template>
                <b-spinner
                  style="width: 1rem !important; height: 1rem !important"
                  v-else
                  variant="light"
                  label="Spinning"
                ></b-spinner>
              </b-button>
          
          </template>
				</b-modal>

  </div>

  
</template>

<script>
import { baseInstanceAxios } from "@/assets/js/axiosBase.js";
import { OBJETIVOS} from '@/assets/js/appConstants'; 
import Cursos from "@/views/compra/cursos"; 
import cursosJson  from '@/locales/material/cursos-es.json';
import cursosJsonEN  from '@/locales/material/cursos-en.json';
import ModalCursoDetalle from '@/components/modals/curso-detalle'
import ModalCursoDetalle2 from '@/components/modals/curso-detalle-2'

const lang = localStorage.getItem('lang') || 'es';

export default {
  components: {
    Cursos,
    ModalCursoDetalle,
		ModalCursoDetalle2
  },
  data() {
    return {
      showLoadingFirst:false,
      lang:lang,
      subjectId : 0,
      message : '',
      flagFlagGroup:false,
      showSpinnerSave:false,
      listSubjectLevelIds: [],
      flagDropOut : false,
      flagChangeSubject:false,
      flagPlanTest: false,
      flagRepresentative : false,
      limitSubjectChanges : 0,
      nroChangeSubject : 0,
      groupPlanId : 0,
      API_URL: process.env.VUE_APP_API_URL,
      tabIndex: 0,
      flagMostrar: true,
      flagBoton: false,
      childComponentKey: 0,
      subjectLevels: [],
      //cursosJson: cursosJson,
      cursosJson: localStorage.getItem('lang') == 'es' || localStorage.getItem('lang') ==  null ? cursosJson : cursosJsonEN,
      datosCurso:{},
      datosExam:{},
      group: {
        id: 0,
        groupPerson: {
          personStudent: {
            id: 0,
            goalSelected: {
              id: 0
            },
            examSelected: {
              id: 0
            },
          },
        }
      },
      groupsPlan:false
    };
  },
  computed: {
    User: {
      get() {
          return this.$store.state.user;
      },
      set(value) {
          this.$store.commit('mutateUser', value);
      }
    },
    FlagViewFirstOption: {
      get() {
        return (this.$store.state.datosSidebar.flagActivePlan || this.$store.state.datosSidebar.flagViewMenuOptions);
      }
    }
  },
  created() {
    this.userValidPlan();
    this.tabIndex =  this.$route.params.index == undefined ? 0 : this.$route.params.index;
  },
  mounted() {
    if(!this.FlagViewFirstOption){
      this.tabIndex = 1;
    }
    this.getGroupGoal();
    this.getCourses();
    this.group.id = this.$store.state.group_id;
    this.group.groupPerson.personStudent.id = this.$store.state.user.personStudentId;
  },
  methods: {
    userValidPlan(){
 			baseInstanceAxios
        .get(this.API_URL + `/resources/dashboard/GetStudentConsolidatedById?personStudentId=${this.User.personStudentId}` )
        .then(response => {
          console.log(response)
            if(response.data != null && response.data.entity != null){
              // debugger;
              if(response.data.entity.groupsPlan ===null){
                // debugger;
                this.groupsPlan = response.data.entity.groupsPlan;
                this.tabIndex= 1
              }
            }
        });
    },
    changeStateFlag(value){
      this.flagMostrar = value;
      this.toggleShowDivContent(false);
    },
   handleLeaveCourse(){
      this.showSpinnerSave = true;
			
			let datos = {
				Id:this.groupPlanId,
				SubjectLevelId:this.subjectId ,
				UserCreated :  this.$store.state.user.email,
			}; 
 
			baseInstanceAxios
					.post(this.API_URL + `/Resources/Groups/DropOutSubjectLevelsByGroup`, datos)
					.then(response => {
      
						if (response.data != null) {
							if(response.data.return){
                this.message = this.$t('my-cours.mesage-abandoned-course');
             		this.$bvToast.show("toast-check-my-course");
							  this.handleUpdateCourse();
                this.$bvModal.hide("modal-leave");
						  }else{
                this.message = this.$t('mesage-course-error');
                this.$bvToast.show("toast-equis-my-course");
              }
            }
						this.showSpinnerSave = false;
			}).catch(function (error) {

                this.message = this.$t('my-cours.mesage-system-error');
                this.$bvToast.show("toast-equis-my-course");
                this.showSpinnerSave =false;
        });
    },
    handleUpdateCourse(){
        this.getGroupGoal();
        this.getCourses();
        this.group.id = this.$store.state.group_id;
        this.group.groupPerson.personStudent.id = this.$store.state.user.personStudentId;
        this.tabIndex = 0;
    },
    getDisabled(){
      if(!this.flagFlagGroup){
        if(this.flagPlanTest){
          return this.flagPlanTest
        }else{
          
            return !this.flagRepresentative && !this.flagChangeSubject
      
        }
      }else{
        return this.flagFlagGroup
      }
     
    },
    leaveCouse(item){
      
      this.subjectId = item.id
      this.$bvModal.show("modal-leave");
    
    },
    getCourses: function(){
      this.showLoadingFirst = true;
      
      baseInstanceAxios
      .get(this.API_URL + `/resources/GroupsPersons/GetGroupsPersonsDetailsByChangeSubject?IdGroupPerson=${this.$store.state.group_person_id}`)
      .then(response => {
           
        if(response.data != null && response.data.entity != null){
          
          this.subjectLevels = response.data.entity.listSubjectLevels;
          this.groupPlanId = response.data.entity.groupsPlan.id; 
          this.flagFlagGroup =response.data.entity.group.flagGroup;
          this.flagRepresentative =  response.data.entity.flagRepresentative
          // console.log('COURSES',this.subjectLevels)
          this.limitSubjectChanges = response.data.entity.groupsPlan.limitSubjectChanges
          this.nroChangeSubject = response.data.entity.nroByChangeSubject
          this.flagPlanTest = response.data.entity.groupsPlan.flagPlanTest
          this.flagChangeSubject = response.data.entity.flagChangeSubject
          this.flagDropOut  = response.data.entity.flagDropOut
          
          //this.listSubjectLevelIds = response.data.entity.listSubjectLevelIds ? response.data.entity.listSubjectLevelIds  : [];
          
          var programClaseConversacionId = 3;

          this.listSubjectLevelIds = this.subjectLevels.map(e => (e.subject.programId == programClaseConversacionId ? e.subject.id : e.id));

          this.toggleShowDivContent();
        }

          this.showLoadingFirst = false;
      });
    },
    getGroupGoal: function(){
      baseInstanceAxios
      .get(this.API_URL + `/resources/Groups/GetGroupGoal?idStudent=${this.$store.state.user.personStudentId}`)
      .then(response => {
        if(response.data != null && response.data.entity != null){
          this.group.groupPerson.personStudent.goalSelected = response.data.entity.goal;
          this.group.groupPerson.personStudent.examSelected = response.data.entity.subject;
          
        }
      });
    },
    forceRerender() {
      this.childComponentKey += 1;
    },
    getImgObjetivoUrl(name) {
		 
			if(name != null){
				let codeObjImg =  name.replaceAll("0", "")
				return  require(`@/assets/img/${codeObjImg}`);
			}else{
				return null;
			}
		},
    showModalDetalle(id,courses) {
  			if(courses.subject.program.flagExamen == false){
				this.datosCurso = {
					programId: id,
					level:courses.level.abbreviation, 
					grade:courses.subject.orden == null ? "" : courses.subject.orden
				};
       
				this.$bvModal.show("modal-curso-detalle") 
			}else{
      
				this.datosExam = {
					codigo:courses.nameSubject.replaceAll(" ", "_"), 
					name: courses.nameSubject
				}
        
				this.$bvModal.show("modal-curso-detalle-2") 
			}
		},
    toggleShowDivContent(flagFirstOption = true){
      if(flagFirstOption && this.subjectLevels.length == 0){
        this.$refs.refContentTabs.$refs.content.style.display = 'none';
      }else{
        this.$refs.refContentTabs.$refs.content.style.display = 'block';
      }
    }
  },
};
</script>